'use client';

import React__default, { useContext } from 'react';

var ReportJobModalContext = React__default.createContext({
    data: null,
    language: '',
    useGlobalToast: false,
    t: function (text) { return ''; },
    locationClassName: "",
});
var useReportJob = function () { return useContext(ReportJobModalContext); };

export { ReportJobModalContext, useReportJob };
//# sourceMappingURL=hooks.js.map
